export const JOIN_ROOM_STAGES = { room: 1, accepted: 2 };
